import React from 'react';
import useHabitatInsightsUpload from 'src/app/habitat-insights/views/habitat-insights-details/components/habitat-insights-upload/hooks/useHabitatInsightsUpload';
import HabitatInsightsSamples from './components/habitat-insights-samples/HabitatInsightsSamples';
import ReviewAndSubmit from './components/review-and-submit/ReviewAndSubmit';

export const HabitatInsightsUpload = () => {
    const { formState } = useHabitatInsightsUpload();
    return (
        <>
            <div className='flex flex-col gap-[25px]'>
                <div className='w-full flex flex-col'>
                    <div className='text-black text-[17px] border-b border-[#4a4a4a] mb-[40px]'>Remote sensing - Areas of interest</div>
                    <HabitatInsightsSamples />
                </div>
            </div>
            {formState.uploadedFileContent && (
                <div className='h-full overflow-auto pb-[50px]'>
                    {' '}
                    <ReviewAndSubmit />
                </div>
            )}
        </>
    );
};

export default HabitatInsightsUpload;
